import BookConsultation from "../../../components/BookConsultation/BookConsultation";
import React from "react";

export default function index() {
  return (
    <>
      <BookConsultation />
    </>
  );
}